var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "customer-invoices-bankdrafts-container",
        _setup.breakpointClass,
        "pa-0",
      ],
    },
    [
      _setup.loading
        ? _c(_setup.SpinnerLayerComponent, { staticClass: "spinner-layer" })
        : [
            _setup.alert
              ? _c(_setup.StaticAlertComponent, {
                  attrs: { alert: _setup.alert },
                })
              : _vm._e(),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    staticClass: "customer-invoices-form",
                    attrs: { cols: "12" },
                  },
                  [
                    _setup.generatorFormSchema && _setup.registerFormData
                      ? _c(_setup.FormGeneratorComponent, {
                          attrs: {
                            schema: _setup.generatorFormSchema,
                            fieldValues: _setup.registerFormData,
                            context: _setup.generatorFormContext,
                            permissionsEntity: _setup.permissionsEntity,
                            validateOnLoad: "",
                          },
                          on: {
                            lexonButtonEvent: _setup.onAutomaticBankdraft,
                            saveFormData: _setup.onChangeGeneratorForm,
                            isValidForm: _setup.onIsValidForm,
                            "emit-on-blur-event": function ($event) {
                              return _setup.invoicesMaxNumberFormFieldsLogicMixin.fillTextfieldFields(
                                _setup.registerFormData,
                                _setup.selectedInvoiceCompanyInfoCloned
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "billing-totals", attrs: { cols: "12" } },
                  [
                    _c(_setup.LfTotalsComponent, {
                      attrs: { items: _setup.totals },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "grid-container", attrs: { cols: "12" } },
                  [
                    _setup.gridConfiguration
                      ? _c(_setup.LfGridComponent, {
                          attrs: {
                            gridConfiguration: _setup.gridConfiguration,
                            itemData: _setup.bankdraftList,
                            toolbarOptions: _setup.toolbarOptionsCustom,
                            commandClick: _setup.onCommandClick,
                            contextMenuItems: _setup.contextMenuItems,
                            childGrid: _setup.miniGrid,
                            rowDataBound: _setup.onRowDataBound,
                            exportName: _setup.texts.gridTitle,
                          },
                          on: {
                            toolbarClicked: _setup.onToolbarClicked,
                            rowClick: _setup.onRowClicked,
                            contextMenuClicked: _setup.onContextMenuClicked,
                          },
                        })
                      : _vm._e(),
                    _c(_setup.PromptDialogComponent, {
                      attrs: {
                        title: _setup.bankdraftPromptTitle,
                        isOpened: _setup.bankdraftPromptOpened,
                        context: _setup.bankdraftFormContext,
                        formSchema: _setup.bankdraftFormSchema,
                        formFieldValues: _setup.bankdraftFormData,
                        width: 950,
                        showRequiredFieldsAdvice: false,
                      },
                      on: {
                        "execute-action": _setup.onBankdraftPromptExecuteAction,
                        changeFormField: _setup.onChangeBankdraftForm,
                      },
                    }),
                    _c(_setup.PromptDialogComponent, {
                      attrs: {
                        title: _setup.partialbankdraftPromptTitle,
                        isOpened: _setup.partialbankdraftPromptOpened,
                        context: _setup.partialbankdraftFormContext,
                        formSchema: _setup.partialbankdraftFormSchema,
                        formFieldValues: _setup.partialbankdraftFormData,
                        width: 950,
                      },
                      on: {
                        "execute-action":
                          _setup.onPartialbankdraftPromptExecuteAction,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }